import { CountDown } from './components/CountDown';
import { BaseScene } from './BaseScene';

export class WelcomeScene extends BaseScene {
  constructor() {
    super('WelcomeScene', true);
  }

  createBody() {
    new CountDown(this, this.screenWidth, this.screenHeight);
  }

  cleanUpListeners() {}
}
